import { createContext } from 'react';

export interface mouseSelectionContextProps {
  useMouseSelection: boolean;
  setUseMouseSelection: (value: boolean) => void;
}

export const mouseSelectionContext = createContext<mouseSelectionContextProps>({
  useMouseSelection: false,
  setUseMouseSelection: () => {},
});
